<template>
  <generic-modal :title="$t('restaurant product')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column is-5">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("price") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.settings.price" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("options") }}</label>
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_drink"
              name="chk_is_drink"
              v-model="meta.settings.is_drink"
            />
            <label for="chk_is_drink">{{ $t("is drink") }}</label>
          </div>
        </div>
      </div>
      <div class="field" v-if="meta.settings">
        <label class="label">{{ $t("description") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.settings.description"
          ></textarea>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "RestaurantProductModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.settings.price;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/restaurant/product", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/restaurant/product", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/restaurant/product", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
